<template>
  <div>
    <div class="flex items-center gap-3 mb-4">
      <Webhook class="w-7 h-7 text-foreground" />
      <h1 class="text-2xl font-semibold tracking-tight text-foreground">SDK Preview</h1>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <div style="zoom: 90%" class="col-span-2 mt-5 text-lg mb-5">
        <div class="iphone-outer-frame mx-auto">
          <div class="iphone-inner-frame">
            <div class="iphone-notch"></div>
            <div
              :key="componentKey"
              :style="`background-color:${sdkColours.backgroundColour}; color:${sdkColours.primaryTextColour} `"
              class="screen-content"
            >
              <div id="offerSDKHolder" class="w-full"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Webhook } from 'lucide-vue-next'
import BoogiSDK from 'boogi-javascript-sdk'

export default {
  name: 'manage-sdk',
  components: {
    Webhook,
  },
  data() {
    return {
      loading: false,
      componentKey: 0,

      sdkColours: {
        sectionLabelTitleColour: '#F6F6F6',
        sectionLabelSubTitleColour: '#B3B5B9',
        primaryTextColour: '#F6F6F6',
        secondaryTextColour: '#B3B5B9',
        highlightTextColour: '#73f46c',
        cardBackgroundColour: '#000814',
        cardBorderColour: '#000814',
        dividerColour: '#333943',
        primaryButtonBackground: '#fcbc2c',
        primaryButtonBorder: '#fcbc2c',
        primaryButtonTextColour: '#19212B',
        secondaryButtonBackground: '#323943',
        secondaryButtonBorder: '#323943',
        secondaryButtonTextColour: '#CAD5E6',
        backgroundColour: '#19212B',
      },
    }
  },
  created() {
    this.getColoursSDK()
  },
  methods: {
    async fetchIdFromAPI() {
      const token = localStorage.getItem('token')
      const api = localStorage.getItem('apiType')
      const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL
      try {
        const response = await fetch(`${apiUrl}/private/api/client/api-key/sdk/token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        })

        if (!response.ok) {
          throw new Error('Failed to fetch ID from API')
        }
        const data = await response.json()
        const boogiSDK = new BoogiSDK()
        boogiSDK.displayOffers(data.token, api, 'offerSDKHolder', { height: '100%' })
      } catch (error) {
        console.error('Error fetching ID from API:', error)
      }
    },

    async getColoursSDK() {
      try {
        const token = localStorage.getItem('token')
        const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL

        this.loading = true
        const response = await fetch(`${apiUrl}/private/api/client/sdk`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        })

        if (response.ok) {
          var object = await response.json()
          this.sdkColours = object
          delete this.sdkColours.createdOn
          delete this.sdkColours.id
          delete this.sdkColours.updatedOn
          delete this.sdkColours.publisherId

          this.loading = false
          this.fetchIdFromAPI()
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>
<style scoped>
.iphone-outer-frame {
  width: 400px;
  height: 850px;
  border-radius: 50px;
  background: linear-gradient(145deg, #444, #222);
  /* padding: 10px; */
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  /* box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.3); */
}

/* Inner iPhone Frame */
.iphone-inner-frame {
  width: 375px;
  height: 850px;
  border-radius: 40px;
  height: 812px;
  position: relative;
  overflow: hidden;
  align-items: center;
}

/* iPhone Notch */
.iphone-notch {
  width: 210px;
  height: 30px;
  background: #000;
  border-radius: 0 0 20px 20px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

/* Header */
.header {
  width: 100%;
  background-color: #fff;
  padding: 15px 20px;
  text-align: center;
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;
}

/* Screen Content */
.screen-content {
  width: 100%;
  background-color: white;
  border-radius: 30px 30px 0 0; /* Rounded top corners only */
  margin-top: 10px; /* Adjust for spacing */

  align-items: center;
  height: 100%;
}

/* Inner Content */
#offerSDKHolder {
  max-width: 500px;
  height: 100%;
  width: 100%;
  margin: 0 auto;
}
iframe {
  height: 100%;
}

/* Footer Nav */
</style>
